<template>
  <div class="body container">
    <!--导航-->
    <div class="nav clearfix">
      <a
        href="javascript:;"
        @click="jumpToList(item.fix_column_name, item.id)"
        v-for="item in columnData"
        :key="item.id"
        :class="item.id == id ? 'active' : ''"
        >{{ item.title }}</a
      >
    </div>
    <div class="content wrapper clearfix">
      <div class="resourceBox fl">
        <div class="sortBox clearfix">
          <div class="searchBox fr">
            <span class="des">共{{ totle }}条结果</span>
            <div>
              <el-input
                v-model="keyword"
                placeholder="关键字搜索，标题"
                class="handle-input mr10 keyword"
                @keyup.enter.native="getActivityInfoList"
              ></el-input>
              <a class="searchBtn" @click="getActivityInfoList"></a>
            </div>
          </div>
        </div>
        <ul class="collective-lessons-list clearfix" v-if="ActivityList.length">
          <li class="item" v-for="item in ActivityList" :key="item.id">
            <h2>
              <a
                class="title"
                href="javascript:;"
                @click="
                  jumpToInfo(
                    item.id,
                    item.activity_permission,
                    item.member_list,
                    item.userid
                  )
                "
                >{{ item.title }}</a
              >
              <span :class="item.colorClass">{{ item.statusname }}</span>
            </h2>
            <p class="row1">
              <span class="s1">起止时间：</span>
              <span class="s2"
                >{{ item.begin_time.substr(0, 16) }} ~
                {{ item.end_time.substr(0, 16) }}</span
              >
            </p>
            <p class="row2">
              <span class="row_1">主持人：{{ item.username }}</span>
              <span>参与人数：{{ item.member_list.length }}</span>
              <span
                >权限：{{
                  item.activity_permission == 2 ? "公开" : "仅参与人员"
                }}</span
              >
            </p>
          </li>
        </ul>
        <div class="noData" v-if="none">
          <img src="../../assets/img/no_activity.png" />
          <p>咦？暂时没有集体备课哦~~</p>
        </div>
        <div class="btnGroup">
          <div></div>
          <div class="btnGroup" style="background: #f6f9fa">
            <div class="pagination">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                hide-on-single-page
                layout="prev, pager, next"
                :total="totle"
                :current-page="page"
                :page-size="pagesize"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="getHeight"></div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "class",
  data() {
    return {
      schoolid: this.$route.query.schoolid,
      ActivityList: [],
      columnData: [],
      keyword: "",
      page: 1,
      cur_page: 1,
      pagesize: 8,
      none: false,
      login_userid: 1,
      totle: 0,
    };
  },
  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  created() {
    
  },
  methods: {
    init(){
         this.getColumn();
        this.getActivityInfoList();
        this.getLoginUserInfo();
      },
    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {      
      this.login_userid = globalApi.GetUserID();
    },

    // 获取二级菜单
    async getColumn() {
      const index = 700;
      this.id = this.$route.query.id;
      const data = {
        s: "WebSchoolSpace.Column.getSubColumns",
        weblevel: 1,
        columnid: index,
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (response.data.ret != 200) {
        return false;
      }
      if (res.result != 1) {
        return false;
      }
      this.columnData = res.list;
    },
    handleCurrentChange(val) {
      this.cur_page = val;
      document.documentElement.scrollTop = 0;
      this.getActivityInfoList();
    },
    // 获取列表
    async getActivityInfoList() {
      let data = {
        s: "WebSchoolSpace.LessonPreparation.getActivityInfoList",
        page: this.cur_page,
        pagesize: this.pagesize,
        keyword: this.keyword,
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (response.data.ret != 200) {
        return false;
      }

      if (res.result != 1) {
        return false;
      }

      this.ActivityList = res.list;
      this.none = this.ActivityList.length ? false : true;
      this.page = res.page;
      this.totle = res.recordcount;
    },
    jumpToList(colName, val) {
      this.$router.push(
        colName + "?id=" + val + "&schoolid=" + this.$route.query.schoolid
      );
    },
    async jumpToInfo(val, powerId, member_list, userid) {
      var isView = this.checkPower(powerId, member_list);
      if (globalApi.gWebsiteSessionInfo.userid == userid) {
        isView = 1;
      }
      if (isView == 1) {
        globalApi.jumpPath(2, "school_activity_preparation_info", "act_id=" + val);
      }
      if (isView == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
      }
      if (isView == 3) {
        this.$message.error("无访问权限!");
      }
    },
    // 检测权限 1=有权限 2=未登录  3=无权
    checkPower(pwoerId, member_list) {
      if (pwoerId == 2) {
        return 1;
      }
      if (!globalApi.IsLogIned()) {
        return 2;
      }
      const userId = globalApi.GetUserID();
      if (member_list.indexOf(userId) > -1) {
        return 1;
      } else {
        return 3;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/newIndex.css";
@import "../../assets/scss/index_body.scss";
.keyword {
  width: 90%;
}
.status-go {
  color: red;
}
.status-end {
  color: #999999;
}
.row_1 {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.wrapper .resourceBox {
  width: 1200px !important;
}
.collective-lessons-list {
  height: 700px;
}
.collective-lessons-list .item:nth-child(2n) {
  float: right !important;
}

.collective-lessons-list .item {
  float: left !important;
  width: 590px;
  height: 150px;
  padding-left: 20px;
  margin: 10px 0 10px 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  a {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }
  h2 span {
    float: right;
    margin-right: 20px;
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
  }
  .row1 {
    padding: 5px 0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    .s1 {
      color: rgba(153, 153, 153, 1);
    }
    .s2 {
      color: rgba(0, 136, 255, 1);
    }
  }
  .row2 {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    span {
      margin-right: 30px;
    }
  }
}
.wrapper {
  min-height: 800px !important;
}
.btnGroup {
  margin-bottom: 10px !important;
  margin-top: 0px !important;
}
.none-info-2 {
  width: 100%;
  height: 500px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: rgb(160, 171, 186);
}
.none-info-2 img {
  width: 35%;
  display: block;
  margin: 100px auto;
  margin-bottom: 10px;
}
.none-info-2 span {
  position: relative;
  left: -15px;
}
</style>

